var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Thumbnail", {
    attrs: { rounded: _vm.rounded },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function () {
          return [
            _c("KIcon", {
              attrs: { icon: "exercise", color: _vm.$themePalette.grey.v_700 },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }